import { Group } from '../core-data-model/Group.model';
import { SearchResult } from '../core-data-model/SearchResult.model';
import { SortInfo } from '../core-data-model/SortInfo.model';
import { ClientTable } from '../core-services/ClientTable';
import { SearchStateFactory } from '../core-services/SearchStateFactory';
import { TeamsApi } from '../core-services/TeamsApi.connect';
import { SortingFunction } from '../text-utilities/Sort.utility';
import { TranslationService } from '../translations';

export class GroupTable extends ClientTable<SearchResult> {
    constructor(
        private group: Group,
        private teamsApi: TeamsApi,
        searchFactory: SearchStateFactory,
        private TR: TranslationService
    ) {
        super('groupPage');
        this.contents = [];
        this.searchState = searchFactory.newSearchState();
    }

    protected async fetchRawData(): Promise<any[]> {
        const groupContents = await this.teamsApi.getGroupContents(
            this.group.id,
            this.searchState.setPageSize(this.group.peopleAndJobCount)
        );
        return groupContents;
    }
    protected filterByTerm(item: any, myRegex: RegExp): boolean {
        // No filtering on group table yet
        throw new Error('Method not implemented.');
    }

    // TODO move all sorts into SearchResult statics
    protected getSort(sortInfo: SortInfo): SortingFunction<any> {
        return this.sortUtilities.makeSearchResultSort(sortInfo.sortType);
    }

    async getCopyOfContents() {
        // return a copy
        const contents = await this.internalFetchRawData();
        return contents.map((x) => x);
    }
}
